/**
 * service-dossiers-en.ts — English dossier accessors.
 *
 * Reads the generated English mirrors and exposes the same shape as the Thai
 * dataset so the /en/case-study routes stay a thin presentation layer.
 */
import type { ServiceDossier } from "./service-dossiers";
import { EN_DOSSIER_RECORD } from "./service-dossiers-en.generated";
import { EN_AUTHORED_DOSSIERS } from "./service-dossiers-en.authored";
import { EN_AUTHORED_DOSSIERS_B } from "./service-dossiers-en.authored-b";
import { EN_AUTHORED_DOSSIERS_C } from "./service-dossiers-en.authored-c";
import { EN_AUTHORED_DOSSIERS_D } from "./service-dossiers-en.authored-d";
import { EN_AUTHORED_DOSSIERS_E } from "./service-dossiers-en.authored-e";

const merged: Record<string, ServiceDossier> = { ...EN_DOSSIER_RECORD };
for (const d of [...EN_AUTHORED_DOSSIERS, ...EN_AUTHORED_DOSSIERS_B, ...EN_AUTHORED_DOSSIERS_C, ...EN_AUTHORED_DOSSIERS_D, ...EN_AUTHORED_DOSSIERS_E]) merged[d.slug] = d;



export const EN_DOSSIERS: ServiceDossier[] = Object.values(merged);
export const EN_DOSSIER_BY_SLUG = new Map(EN_DOSSIERS.map((d) => [d.slug, d]));
export const EN_DOSSIER_SLUGS = EN_DOSSIERS.map((d) => d.slug);
export const hasEnDossier = (slug: string) => EN_DOSSIER_BY_SLUG.has(slug);

